import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Button,
    FlexBox,
    FormField,
    FormInputGroup,
    Icon,
    StandardForm,
    TextInput,
} from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';

const BusinessNameInput = () => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);
    const [businessName, setBusinessName] = useState('');
    const logomakerGenAiPath = logomakerCtaPathByLocale(locale);
    const logomakerCTARef = useTrackNavigationClicked(
        'Design Services',
        'Hero Banner CTA',
        logomakerGenAiPath,
        'logoMaker',
    );

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBusinessName(e.target.value);
    };

    const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        // TODO: replace with new Contentful string for Logomaker GenAI page
        window.location.href = `${logomakerGenAiPath}?businessName=${encodeURIComponent(businessName)}`;
    };

    return (
        <StandardForm onSubmit={handleOnSubmit} style={{ flexGrow: 1 }}>
            <FlexBox flexDirection={{ xs: 'column', sm: 'row' }} justifyContent="space-between">
                <FormField style={{ flexGrow: 1 }}>
                    <FormInputGroup marginBottom="0">
                        <TextInput
                            name="businessName"
                            placeholder={t(
                                'Logomaker GenAi Landing Page > Hero > Input > Placeholder.value',
                            )}
                            aria-label={t(
                                'Logomaker GenAi Landing Page > Hero > Input > Aria Label.value',
                            )}
                            value={businessName}
                            onChange={handleOnChange}
                        />
                    </FormInputGroup>
                </FormField>
                <Box
                    marginLeft={{ xs: 0, sm: 'between-actions' }}
                    marginTop={{ xs: 'between-actions', sm: 0 }}
                    style={{ flexShrink: 0 }}
                >
                    <Button skin="primary" textAlign="center" type="submit" ref={logomakerCTARef}>
                        <Icon alt="next step" iconType="magic" />
                        {t('Logomaker GenAi Landing Page > Hero > CTA > Text.value')}
                    </Button>
                </Box>
            </FlexBox>
        </StandardForm>
    );
};

export default BusinessNameInput;
